import React, { useEffect, useState } from 'react';
import UserService from 'views/User/service';
import { Controller, useForm } from 'react-hook-form';
import { Form, CardBody, Button } from 'reactstrap';
import * as Yup from 'yup';
import * as S from './styles';
import { yupResolver } from '@hookform/resolvers/yup';
import FlexSelect from 'components/Inputs/FlexSelect';
import { ErrorMessage } from '@hookform/error-message';

const schema = Yup.object().shape({
  queueIds: Yup.array().nullable().required('Selecione pelo menos uma fila')
});

export const AddQueueForm = ({
  handlerAddQueue,
  queues,
  handleCancel = () => {},
  loading = false
}) => {
  const { control, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema)
  });
  const [userQueueIds, setUserQueueIds] = useState([]);
  useEffect(() => {
    const fetchUserQueues = async () => {
      try {
        const login = localStorage.getItem('login') || '';
        const response = await UserService.getAllSeachUser(
          1,
          10,
          login,
          false,
          '',
          'name',
          'asc',
          'contexto'
        );
        const userList = response.data?.data;
        if (Array.isArray(userList) && userList.length > 0) {
          const userQueues = userList[0]?.queues || [];
          const queueIds = userQueues.map((q) => q.id);
          setUserQueueIds(queueIds);
        } else {
          setUserQueueIds([]);
        }
      } catch (e) {
        setUserQueueIds([]);
      }
    };
    fetchUserQueues();
  }, []);
  return (
    <CardBody>
      <Form
        className="needs-validation"
        onSubmit={handleSubmit(handlerAddQueue)}
      >
        <div className="mb-2">
          <Controller
            render={(props) => (
              <FlexSelect
                isClearable={true}
                dataOptions={queues.filter((q) => userQueueIds.includes(q.id))}
                isMulti={true}
                closeMenuOnSelect={false}
                value={props.value}
                valueController={setValue}
                fieldName="queueIds"
                labelName="name"
                valueName="id"
                minHeight="1rem"
              />
            )}
            control={control}
            name="queueIds"
            defaultValue=""
          />

          <ErrorMessage
            errors={errors}
            name="queueIds"
            render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
          />
        </div>

        <S.ButtonsWrapper>
          <Button color="danger" type="button" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            Logar
          </Button>
        </S.ButtonsWrapper>
      </Form>
    </CardBody>
  );
};
